const DEFAULTS = {
  oauth: {
    title: 'Giriş tamamlanamadı',
    titleEn: 'Sign-in incomplete',
    message: 'Sosyal giriş başarısız',
    messageEn: 'Social login failed',
    button: 'Ana sayfaya dön',
    buttonEn: 'Back to home',
    buttonBg: '#d42a28',
    buttonColor: '#ffffff',
  },
  route: {
    title: 'Sayfa yüklenemedi',
    titleEn: 'Page failed to load',
    message: 'Beklenmeyen bir hata oluştu. Yenileyip tekrar deneyin.',
    messageEn: 'Something went wrong. Please refresh and try again.',
    button: 'Yenile',
    buttonEn: 'Refresh',
    buttonBg: '#d42a28',
    buttonColor: '#ffffff',
  },
  generic: {
    title: 'Bir hata oluştu',
    titleEn: 'Something went wrong',
    message: 'İşlem tamamlanamadı. Lütfen tekrar deneyin.',
    messageEn: 'The action could not be completed. Please try again.',
    button: 'Ana sayfaya dön',
    buttonEn: 'Back to home',
    buttonBg: '#d42a28',
    buttonColor: '#ffffff',
  },
  notFound: {
    title: 'Sayfa bulunamadı',
    titleEn: 'Page not found',
    message: 'Aradığınız sayfa mevcut değil veya taşınmış olabilir.',
    messageEn: 'The page you are looking for does not exist or may have moved.',
    button: 'Ana sayfaya dön',
    buttonEn: 'Back to home',
    buttonBg: '#d42a28',
    buttonColor: '#ffffff',
  },
};

export function getErrorPageDefaults(kind = 'generic') {
  return DEFAULTS[kind] || DEFAULTS.generic;
}

export default function SiteErrorView({
  kind = 'generic',
  title,
  message,
  buttonLabel,
  buttonBg,
  buttonColor,
  onAction,
}) {
  const fallback = getErrorPageDefaults(kind);
  const bg = buttonBg || fallback.buttonBg;
  const color = buttonColor || fallback.buttonColor;

  return (
    <div className="site-error" role="alert">
      <h1 className="site-error__title">{title || fallback.title}</h1>
      {message ? <p className="site-error__message">{message}</p> : null}
      {onAction ? (
        <button
          type="button"
          className="site-error__btn"
          style={{ background: bg, color }}
          onClick={onAction}
        >
          {buttonLabel || fallback.button}
        </button>
      ) : null}
    </div>
  );
}
